var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLoader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #ffc905;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #f6e9cf;\r\n      }\r\n\r\n      .st2 {\r\n        display: none;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #f37a20;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-ca920482-1009-45e2-b6b5-2007aa9d8d72",
    "data-name": "Layer_11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94,544.4v40.8c0,26.1-13.8,39.1-41.3,39-28.5,0-42.7-15.1-42.7-45.4v-75.9c0-30.2,14.3-45.3,42.7-45.3s41.3,11.8,41.3,39.2v36.5h-36v-39.8c0-4.6-1.8-6.9-5.3-6.9s-5.3,2.3-5.3,6.9v94.5c0,4.6,1.9,6.9,5.5,6.9s5.2-2.3,5.2-6.9v-43.7h36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146,527.6l1.6-18.7,5.5-48h38.7l-29.2,123.1v40.3h-36.3v-40.1l-29.4-123.2h39.6l5.8,48,1.4,18.7h2.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.3,540.8c12.3,3.5,18.5,12,18.5,25.7v26.2c0,9.7-3.1,17.3-9.4,23-6.3,5.7-15.4,8.5-27.1,8.5h-48v-163.3h49.7c10.1,0,18.2,2.5,24.4,7.3s9.2,11.9,9.2,21.1v25c0,13.5-5.7,22-17.3,25.5v1h0,0ZM232.6,489.5v38.7h5c4.1,0,6.1-2.3,6.1-6.8v-24.8c0-4.7-2.1-7.1-6.2-7.1h-4.8s0,0,0,0ZM232.6,553v42.7h4.3c5.1,0,7.6-2.8,7.6-8.4v-25.9c0-5.6-2.4-8.3-7.4-8.3h-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325.1,593.7h31.9v30.5h-68.2v-163.3h67.7v30.5h-31.4v34.8h29.7v28.9h-29.7v38.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,624.2h-37.6l-5.1-54.4h-7.6v54.4h-36.3v-163.3h46.4c25.1,0,37.7,12.9,37.7,36v31.7c0,10.2-2.6,18.5-7.9,24.7l10.4,70.9h0ZM402.4,542.3h3c5.1,0,7.6-3.8,7.7-11.4v-29.5c0-6.6-2.5-9.9-7.7-9.9h-3v50.8h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 470.3,
    y: 459.6,
    width: 71.9,
    height: 164.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M498.1,581.6v10.6h-6.6c-1.2,0-1.9.5-1.9,1.6s.6,1.6,1.7,1.6h6.1c1.1,0,2-.6,2.4-1.7l1.2-5c.7-2.6,1.8-4.5,3.2-5.8,1.5-1.3,3.7-2,6.7-2h8.1c3.6,0,6.5,1.1,8.5,3.3s3,5.3,3,9.3c0,8.2-3.5,12.5-9.9,12.5h-8.6v-10.8h8c1.1,0,1.9-.6,1.9-1.7s-.7-1.7-1.7-1.7h-7.6c-1.2,0-2.1.7-2.6,2.1l-1,4c-.6,2.9-1.7,5-3.3,6.3s-4,2-7.1,2h-6.6c-3.4,0-6-1.1-8-3.2-1.9-2.2-2.9-5.3-2.9-9.4s.9-6.8,2.5-9c1.7-2.1,4.1-3.2,7.1-3.2h7.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M516.9,567.6h13.3v10.8h-48.4v-14c0-3.5,1-6.3,3-8.2,2-1.9,4.9-2.9,8.6-2.9h11.3c3.6,0,6.6,1,8.8,3,2.3,2,3.4,4.7,3.4,8.1v3.2h0ZM507.8,566.6c0-1.5-1-2.2-2.9-2.2h-11.4c-1.9,0-2.8.7-2.8,2.2v1h17.1v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M530.1,537.8l-8.8.5v4.2s8.8.5,8.8.5v11.1l-48.4-5.1v-17.5l48.4-5v11.2h0ZM512.7,542v-3.2l-15.6.9-5.8.3v.7l5.8.3,15.6.9h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M507,501.2h12.1c7.7,0,11.6,4.1,11.6,12.2,0,8.4-4.5,12.7-13.5,12.7h-22.5c-9,0-13.4-4.2-13.4-12.7s3.5-12.2,11.6-12.2h10.8v10.6h-11.8c-1.4,0-2,.5-2,1.6s.7,1.6,2,1.6h28c1.4,0,2-.5,2-1.6s-.7-1.5-2-1.5h-13v-10.7h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M521.1,487.6v-9.5h9v20.2h-48.4v-20.1h9v9.3h10.3v-8.8h8.6v8.8h11.4,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606.2,462.5c25.1,0,39.7,13.2,39.7,39.7v83.2c0,12.8-3.5,22.4-10.6,29-7.1,6.6-16.8,9.9-29.1,9.9h-43.6v-161.8h43.6ZM609.2,499.9c0-4.8-2-7.2-6-7.2h-4.6v101.2h4.4c4.1,0,6.2-2.5,6.2-7.3v-86.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M655.7,462.5h35.9v161.7h-35.9v-161.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M751,606.8c-1.8,6.3-4.4,10.8-7.8,13.4-3.3,2.7-8.2,4-14.6,4s-15-3.1-20-9.3c-4.9-6.1-7.4-15.3-7.4-27.5v-83.3c0-30.5,14.2-44.9,43-44.9s40.5,12.3,40.5,35.6v32.3h-36.4v-32.4c0-4.6-1.8-6.9-5.4-6.9s-5.3,2.2-5.3,6.9v94.6c0,4.4,1.9,6.7,5.7,6.7s5.8-2.3,5.8-7v-31h-5.3v-23h41v87.5h-28.6l-3.1-15.7h-1.9,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M794.5,462.5h35.9v161.7h-35.9v-161.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M912.9,462.5v30.1h-20.1v131.6h-35.9v-131.5h-20.6v-30.2h76.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M961,624.2l-1.7-29.4-14.2-.2-1.8,29.6h-37.1l17.1-161.8h58.5l16.6,161.8h-37.5,0s0,0,0,0ZM947,566h10.6l-2.9-52.1-1.2-19.3h-2.2l-1.2,19.3-3.1,52.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1043.3,593.7h26.7v30.5h-63v-163.1h36.2v132.6Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.4,651.1l.2-2.9.9-7.5h6l-4.5,19.1v6.3h-5.6v-6.2l-4.6-19.2h6.1l.9,7.5.2,2.9h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307,647.5v11.8c0,4.8-2.2,7.1-6.7,7.1s-6.6-2.3-6.6-7.1v-11.8c0-4.7,2.2-7,6.6-7s6.7,2.2,6.7,7ZM301.2,646.1c0-.7-.3-1.1-.9-1.1s-.9.4-.9,1.1v14.7c0,.7.3,1.1.9,1.1s.9-.4.9-1.1v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322,640.8v20.1c0,3.7-2.4,5.6-6.6,5.6s-6.4-1.8-6.4-5.6v-20.1h5.6v20.1c0,.7.3,1,.8,1,.5,0,.8-.3.8-1v-20.1h5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.7,666.2h-5.8l-.8-8.5h-1.2v8.5h-5.6v-25.4h7.2c3.9,0,5.9,2,5.9,5.6v4.9c0,1.6-.4,2.9-1.2,3.8l1.6,11h0,0ZM329.8,653.4h.5c.8,0,1.2-.6,1.2-1.8v-4.6c0-1-.4-1.5-1.2-1.5h-.5v7.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.8,640.8h5.8l-2.6,25.4h-8.7l-2.6-25.4h5.8l.9,15.3.3,4.2h.4l.2-4.2.7-15.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.8,640.8h5.6v25.4h-5.6v-25.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.4,649.3h-5.6v-3.4c0-.6-.3-1-.9-1s-.8.3-.8.9v3.2c0,.6.3,1,.9,1.3l2.6.6c1.4.4,2.4.9,3.1,1.7.7.8,1,1.9,1,3.5v4.2c0,1.9-.6,3.4-1.7,4.5-1.2,1.1-2.8,1.6-4.9,1.6-4.3,0-6.5-1.8-6.5-5.2v-4.5h5.6v4.2c0,.6.3,1,.9,1s.9-.4.9-.9v-4c0-.6-.4-1.1-1.1-1.3l-2.1-.5c-1.5-.3-2.6-.9-3.3-1.7s-1-2.1-1-3.8v-3.5c0-1.8.6-3.2,1.7-4.2,1.1-1,2.8-1.5,4.9-1.5s3.6.5,4.7,1.3c1.1.9,1.7,2.2,1.7,3.7v3.8h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.6,640.8h5.6v25.4h-5.6v-25.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.7,647.5v11.8c0,4.8-2.2,7.1-6.7,7.1s-6.6-2.3-6.6-7.1v-11.8c0-4.7,2.2-7,6.6-7s6.7,2.2,6.7,7ZM396.9,646.1c0-.7-.3-1.1-.9-1.1s-.9.4-.9,1.1v14.7c0,.7.3,1.1.9,1.1s.9-.4.9-1.1v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413,653.2l-.4-5.7v-6.8h5.4v25.4h-5.5l-2.6-13.3h-.3l.3,5.8v7.4h-5.4v-25.4h5.6l2.4,12.5h.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.9,660.2h5.3v6.4c0,1.7-1.1,2.5-3.2,2.5h-2.1v-1.7h1.3c.7,0,1-.3,1-.8v-.4h-2.4v-6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M452.1,647.5v11.8c0,4.8-2.2,7.1-6.7,7.1s-6.6-2.3-6.6-7.1v-11.8c0-4.7,2.2-7,6.6-7s6.7,2.2,6.7,7ZM446.4,646.1c0-.7-.3-1.1-.9-1.1s-.9.4-.9,1.1v14.7c0,.7.3,1.1.9,1.1s.9-.4.9-1.1v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467.1,640.8v20.1c0,3.7-2.4,5.6-6.6,5.6s-6.4-1.8-6.4-5.6v-20.1h5.6v20.1c0,.7.3,1,.8,1,.5,0,.8-.3.8-1v-20.1h5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M482.8,666.2h-5.8l-.8-8.5h-1.2v8.5h-5.6v-25.4h7.2c3.9,0,5.9,2,5.9,5.6v4.9c0,1.6-.4,2.9-1.2,3.8l1.6,11h0,0ZM475,653.4h.5c.8,0,1.2-.6,1.2-1.8v-4.6c0-1-.4-1.5-1.2-1.5h-.5v7.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M502.6,654v6.3c0,4-2.1,6.1-6.4,6.1-4.4,0-6.6-2.3-6.6-7.1v-11.8c0-4.7,2.2-7,6.6-7s6.4,1.8,6.4,6.1v5.7h-5.6v-6.2c0-.7-.3-1.1-.8-1.1s-.8.4-.8,1.1v14.7c0,.7.3,1.1.9,1.1s.8-.4.8-1.1v-6.8h5.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M517.7,647.5v11.8c0,4.8-2.2,7.1-6.7,7.1s-6.6-2.3-6.6-7.1v-11.8c0-4.7,2.2-7,6.6-7s6.7,2.2,6.7,7ZM512,646.1c0-.7-.3-1.1-.9-1.1s-.9.4-.9,1.1v14.7c0,.7.3,1.1.9,1.1s.9-.4.9-1.1v-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.6,640.8c3.9,0,6.2,2.1,6.2,6.2v13.1c0,2-.5,3.5-1.7,4.5-1.1,1-2.6,1.5-4.6,1.5h-6.8v-25.4h6.9ZM527.1,646.6c0-.8-.3-1.1-1-1.1h-.7v15.9h.7c.6,0,1-.4,1-1.1v-13.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M540.6,661.4h5v4.8h-10.6v-25.4h10.5v4.8h-4.9v5.4h4.6v4.5h-4.6v6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M552.1,651.2h10.2v4.7h-10.2v-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M575,659.2v7h-5.6v-25.4h7.3c1.8,0,3.3.5,4.3,1.6,1,1.1,1.5,2.6,1.5,4.5v5.9c0,1.9-.5,3.4-1.6,4.6-1,1.2-2.5,1.8-4.2,1.8h-1.7ZM575.5,654.5c.8,0,1.2-.5,1.2-1.5v-6c0-1-.4-1.5-1.2-1.5h-.5v9h.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M589.8,661.4h5v4.8h-10.6v-25.4h10.5v4.8h-4.9v5.4h4.6v4.5h-4.6v6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M610.1,666.2h-5.8l-.8-8.5h-1.2v8.5h-5.6v-25.4h7.2c3.9,0,5.9,2,5.9,5.6v4.9c0,1.6-.4,2.9-1.2,3.8l1.6,11h0,0ZM602.3,653.4h.5c.8,0,1.2-.6,1.2-1.8v-4.6c0-1-.4-1.5-1.2-1.5h-.5v7.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M622,645.5h-4.5v5.5h4.2s0,4.5,0,4.5h-4.2v10.7h-5.6v-25.4h10.2v4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M629.1,661.4h5v4.8h-10.6v-25.4h10.5v4.8h-4.9v5.4h4.6v4.5h-4.6v6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M648.8,654v6.3c0,4-2.1,6.1-6.4,6.1-4.4,0-6.6-2.3-6.6-7.1v-11.8c0-4.7,2.2-7,6.6-7s6.4,1.8,6.4,6.1v5.7h-5.6v-6.2c0-.7-.3-1.1-.8-1.1s-.8.4-.8,1.1v14.7c0,.7.3,1.1.8,1.1s.8-.4.8-1.1v-6.8h5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M662,640.8v4.7h-3.2v20.7h-5.6v-20.6h-3.2v-4.8h12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M669.1,661.4h4.2v4.8h-9.8v-25.4h5.6v20.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M679.5,651.1l.2-2.9.8-7.5h6l-4.5,19.1v6.3h-5.6v-6.2l-4.6-19.2h6.2l.9,7.5.2,2.9h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M698.7,661.4h5v4.8h-10.6v-25.4h10.5v4.8h-4.9v5.4h4.6v4.5h-4.6v6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M711.6,657.4l-.2,1.5-1,7.2h-5.8l3-13.1-2.7-12.3h5.9l.9,6.8v1.5h.5v-1.5c.1,0,1-6.8,1-6.8h5.7l-2.7,12.1,2.8,13.3h-5.8l-.9-7.2-.2-1.5h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M725.9,661.4h5v4.8h-10.6v-25.4h10.5v4.8h-4.9v5.4h4.6v4.5h-4.6v6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M745.6,654v6.3c0,4-2.1,6.1-6.4,6.1-4.4,0-6.6-2.3-6.6-7.1v-11.8c0-4.7,2.2-7,6.6-7s6.4,1.8,6.4,6.1v5.7h-5.6v-6.2c0-.7-.3-1.1-.8-1.1s-.8.4-.8,1.1v14.7c0,.7.3,1.1.8,1.1s.8-.4.8-1.1v-6.8h5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M760.6,640.8v20.1c0,3.7-2.4,5.6-6.6,5.6s-6.4-1.8-6.4-5.6v-20.1h5.7v20.1c0,.7.3,1,.8,1,.5,0,.8-.3.8-1v-20.1h5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M774,640.8v4.7h-3.2v20.7h-5.6v-20.6h-3.2v-4.8h12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M781.2,661.4h5v4.8h-10.6v-25.4h10.5v4.8h-4.9v5.4h4.6v4.5h-4.6v6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M795,640.8c3.9,0,6.2,2.1,6.2,6.2v13.1c0,2-.5,3.5-1.7,4.5s-2.6,1.5-4.6,1.5h-6.8v-25.4h6.9ZM795.4,646.6c0-.8-.3-1.1-1-1.1h-.7v15.9h.7c.6,0,1-.4,1-1.1v-13.6h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoader);
export default __webpack_public_path__ + "static/media/LogoLoader.0df1b22bc86dc247abe7280fa9e9d00b.svg";
export { ForwardRef as ReactComponent };